<script>
    import {push} from 'svelte-spa-router'

    export let silo;

    function edit(){
        push("/equipment/" + silo.id + "/edit")
    }
</script>

{#if silo !== undefined}
<div class="card">
    <!-- Dropdown option menu -->
    <div class="option-menu">
        <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fas fa-ellipsis-v"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-right">
            <a class="dropdown-item" on:click={edit}><i class="fas fa-pencil-alt"></i> Edit Equipment</a>
        </div>
    </div>
    <!-- END DROPDOWN -->
    <div class="card-body">
        <div class="card-head">
            <h2 class="card-title">{silo.infos.name}</h2>
            <p class="card-subtitle">#{silo.id}</p>

            <div class="padding-top" style="width: 60%;">
                <h5>Material Type</h5>
                <p class="card-highlight">{silo.infos.type}</p>
                <h5>Signal</h5>
                <p class="card-highlight">{silo.lastMessage.signal}</p>
                <h5>Battery</h5>
                <p class="card-highlight">{silo.lastMessage.battery}</p>
                <h5>Last communication with device</h5>
                <p class="card-highlight">
                    <time>{new Date(silo.lastMessage.date).toLocaleString()}</time>
                </p>
            </div>

            <div class="floating-img corner-right">
                <img src="./dist/img/silot_icon_big.png" width="131">
            </div>
        </div>
    </div>
</div>
{/if}